import { DateTime } from "luxon";
import React, { useMemo } from "react";
import { Updater } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useDeleteSchedule } from "../../../../../../api/schedules/delete-schedule";

import { DisabledReason, PanelProps } from "./types";

interface StatusContentProps extends PanelProps {
  setIsScheduling: Updater<boolean>;
}

const DisabledMessages: Record<DisabledReason, string> = {
  startMissing: "Start schedule required",
  pauseSet: "Pause scheduled",
  endSet: "End scheduled",
  testStarted: "",
  testEnded: "",
  testPaused: "",
  priceTest: "Unavailable for Price Tests",
  shippingTest: "Unavailable for Shipping Tests",
};

export const StatusContent = ({
  label,
  color,
  disabledReason,
  setIsScheduling,
  schedule,
  experience,
  isLoading,
}: StatusContentProps) => {
  const deleteSchedule = useDeleteSchedule(experience.id!);
  const ItalicMessages: Partial<Record<DisabledReason, string>> =
    useMemo(() => {
      return {
        testStarted: experience.startedAtTs
          ? `${DateTime.fromMillis(experience.startedAtTs).toLocaleString(
              DateTime.DATETIME_MED
            )}`
          : "",
        testEnded: experience.endedAtTs
          ? `${DateTime.fromMillis(experience.endedAtTs).toLocaleString(
              DateTime.DATETIME_MED
            )}`
          : "",
        testPaused: experience.pausedAtTs
          ? `${DateTime.fromMillis(experience.pausedAtTs).toLocaleString(
              DateTime.DATETIME_MED
            )}`
          : "",
      };
    }, [experience]);

  return (
    <Grid
      container
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ height: "100%" }}
    >
      <Grid item>
        <Grid container item columnSpacing={1}>
          <Grid item>
            <IgTypography sx={{ fontWeight: 600 }}>{label}:</IgTypography>
          </Grid>
          <Grid item>
            <IgTypography sx={{ fontStyle: "italic" }}>
              {schedule?.executionTime
                ? DateTime.fromMillis(schedule.executionTime).toLocaleString(
                    DateTime.DATETIME_MED
                  )
                : disabledReason
                  ? ItalicMessages[disabledReason] || "unscheduled"
                  : "unscheduled"}
            </IgTypography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {disabledReason ? (
          <IgTypography>{DisabledMessages[disabledReason]}</IgTypography>
        ) : (
          <IgButton
            variant={"outlined"}
            color={color}
            loading={deleteSchedule.isPending}
            onClick={() => {
              if (schedule?.id) {
                deleteSchedule.mutate({
                  body: undefined,
                  pathParams: {
                    scheduleId: schedule.id,
                  },
                  queryParams: undefined,
                });
              } else {
                setIsScheduling(true);
              }
            }}
          >
            {schedule?.executionTime ? "Cancel Schedule" : "Schedule"}
          </IgButton>
        )}
      </Grid>
    </Grid>
  );
};
